import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { label: '首页', href: '/' },
  { label: '日本电影', href: '/category/japan' },
  { label: '韩国电影', href: '/category/korea' },
  { label: '动漫剧场版', href: '/category/anime' },
  { label: '剧场版合集', href: '/category/theater' },
  { label: '关于我们', href: '/about' },
];

export default function Navbar() {
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <>
      <header className="fixed top-0 left-0 right-0 z-50 bg-background-50/95 backdrop-blur-md border-b border-background-200/70">
        <nav className="w-full px-4 md:px-6" aria-label="主导航">
          <div className="max-w-7xl mx-auto flex items-center justify-between h-16">
            <Link to="/" className="flex items-center gap-2 flex-shrink-0">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-movie-line text-white text-lg"></i>
              </span>
              <span className="font-heading font-bold text-lg text-foreground-900 whitespace-nowrap">
                日韩大片
              </span>
            </Link>

            <div className="hidden md:flex items-center gap-1">
              {navItems.map((item) => (
                <Link
                  key={item.href}
                  to={item.href}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                    location.pathname === item.href
                      ? 'bg-primary-100 text-primary-700'
                      : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                  }`}
                >
                  {item.label}
                </Link>
              ))}
            </div>

            <button
              className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="打开菜单"
            >
              <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-foreground-700 text-xl`}></i>
            </button>
          </div>

          {isMobileMenuOpen && (
            <div className="md:hidden border-t border-background-200/70 py-3">
              <div className="flex flex-col gap-1">
                {navItems.map((item) => (
                  <Link
                    key={item.href}
                    to={item.href}
                    onClick={() => setIsMobileMenuOpen(false)}
                    className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                      location.pathname === item.href
                        ? 'bg-primary-100 text-primary-700'
                        : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                    }`}
                  >
                    {item.label}
                  </Link>
                ))}
              </div>
            </div>
          )}
        </nav>
      </header>
      <div className="h-16"></div>
    </>
  );
}